module.exports = __webpack_public_path__ + "static/media/twenty.a97c6ac4.jpeg";